import { PropsOf } from 'types';
import connect from './connect';
import TextOverlayModal from './TextOverlayModal';

export default connect(TextOverlayModal);
export type TextOverlayModalProps = PropsOf<ReturnType<typeof connect>>;
